import { analyzeText } from '../wordCounter.js';

function calculate() {
    const text = document.getElementById('resumeText').value;
    const result = analyzeText(text);

    document.getElementById('wordCount').textContent = result.words.toLocaleString();
    document.getElementById('charCount').textContent = result.characters.toLocaleString();
    document.getElementById('charNoSpacesCount').textContent = result.charactersNoSpaces.toLocaleString();
    document.getElementById('sentenceCount').textContent = result.sentences.toLocaleString();
    document.getElementById('readingTime').textContent = `${result.readingTime} min read`;

    const kwList = document.getElementById('keywordList');
    if (result.keywords.length === 0) {
        kwList.innerHTML = '<p style="color: #6b7280; font-size: 0.875rem;">Start typing to see keyword density.</p>';
    } else {
        kwList.innerHTML = result.keywords.map(kw => `
            <div class="kw-item">
                <span>${kw.word}</span>
                <div class="kw-bar-container"><div class="kw-bar" style="width: ${kw.density}%"></div></div>
                <span style="width: 80px; text-align: right;">${kw.count} (${kw.density}%)</span>
            </div>
        `).join('');
    }
}

document.getElementById('resumeText').addEventListener('input', calculate);
// Initial render
calculate();
